import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
// 其他页面在使用axios的时候直接  this.$post就可以了
import { post } from "./axios/index";
Vue.prototype.$post = post;
// 多语言
import i18n from "./commonJs/i18n";
import ViewUI from "view-design";
Vue.use(ViewUI);
import "view-design/dist/styles/iview.css";

import "./assets/css/common.less";
import "./assets/css/css.css";

Vue.use(require("vue-wechat-title"));

Vue.prototype.httpUrl =
  location.origin.indexOf("localhost") != -1 ||
  location.origin.indexOf("192.168.1") != -1
    ? "https://eepay3.dutchlotto.com"
    : location.origin; // 开发服务器取的图片路径
// https://eepay3.dutchlotto.com
Vue.config.productionTip = false;

Vue.prototype._back = () => {
  router.back();
};

// 跳转页面
Vue.prototype._linkFun = (path = "", name = "", query = {}, params = {}) => {
  router.push({
    path: path,
    name: name,
    query: query,
    params: params
  });
};

// 补零
Vue.prototype._zeroFill = value => {
  return value < 10 ? "0" + value : value + "";
};

// 号码格式处理
Vue.prototype._phoneFormat = num => {
  let firstStr = (num + "").substr(0, 1);
  let returnNum = "";
  if (firstStr == "0") {
    returnNum = num
      .toString()
      .replace(/\s/g, "")
      .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
  } else {
    returnNum = num
      .toString()
      .replace(/\s/g, "")
      .replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
  }
  return returnNum;
};

// 比索转换成人民币
Vue.prototype._PHPtoRMB = (a = 0, b = 0) => {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split(".")[1].length;
  } catch (f) {
    // console.log(11)
  }
  try {
    c += e.split(".")[1].length;
  } catch (f) {
    // console.log(11)
  }
  var mun =
    (Number(d.replace(".", "")) * Number(e.replace(".", ""))) / Math.pow(10, c);
  return (Math.round(mun * 100) / 100).toFixed(2);
};

// 输入框金额校验
Vue.prototype._formatter = value => {
  /* eslint-disable */
  value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  value = value
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
  if (value.indexOf(".") < 0 && value != "") {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  return value;
};

// 删除单页面缓存
Vue.prototype._vnodeKeepAlive = (to, from, next, vnode, name = "") => {
  if (vnode && vnode.data.keepAlive && to.name == name) {
    if (
      vnode.parent &&
      vnode.parent.componentInstance &&
      vnode.parent.componentInstance.cache
    ) {
      if (vnode.componentOptions) {
        var key =
          vnode.key == null
            ? vnode.componentOptions.Ctor.cid +
              (vnode.componentOptions.tag
                ? `::${vnode.componentOptions.tag}`
                : "")
            : vnode.key;
        var cache = vnode.parent.componentInstance.cache;
        var keys = vnode.parent.componentInstance.keys;
        if (cache[key]) {
          if (keys.length) {
            var index = keys.indexOf(key);
            if (index > -1) {
              keys.splice(index, 1);
            }
          }
          delete cache[key];
        }
      }
    }
    from.meta.keepAlive = true;
  }
  next();
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
